import { env } from "../env";

export default function service(name) {
  const baseUrl = env.REACT_APP_API_HOSTNAME || env.API_BASE_URL;
  const serviceBaseRoute = env[`${name.toUpperCase()}_SERVICE`];
  const port = env.REACT_APP_API_PORT ? `:${env.REACT_APP_API_PORT}` : "";

  if (!baseUrl || !serviceBaseRoute) {
    console.error("Invalid service api url.");
  }
  return baseUrl + port + serviceBaseRoute;
}
